export default __webpack_public_path__ + "static/media/smart-match.8d351bb1.svg";